export const isAutoCompleteValid = (value, array) => {
    if(value && typeof value === 'object' ) {
        const val = array.some( items => items.id == value.id)
        console.log(val)
        return val ? true : false
    }
    return false;
}
